import * as React from 'react';
import * as autoBind from 'react-autobind';
import CommentModel from '../../types/CommentModel';
import FeedbackContainer from '../Feedback/FeedbackContainer';
import Constants from '../../globals/Constants';
import Strings from '../../globals/Strings';
import LocalStorageWrapper from '../../services/LocalStorageWrapper/LocalStorageWrapper';
import ReplyContainer from '../Reply/ReplyContainer';
import CommentScrollingService from '../../utils/CommentScroller';

export default class CommentReplies extends React.Component<CommentRepliesProps, CommentRepliesState> {
   readonly state: CommentRepliesState = {replyLocalStorageKey: LocalStorageWrapper.getKey(Constants.localStorageKeys.addReply, this.props.parentComment.id, this.props.currentUserId)};
   feedbackContainer: HTMLElement;

   constructor(props: CommentRepliesProps) {
      super(props);
      autoBind(this);
   }

   componentDidMount() {
      if (this.props.hasFocus) {
         CommentScrollingService.scrollCommentIntoView(this.feedbackContainer, {alignment: 'end'});
      }
   }

   componentDidUpdate(prevProps: CommentRepliesProps) {
      if (this.props.parentComment && this.props.parentComment.id !== prevProps.parentComment.id) {
         this.setState({replyLocalStorageKey: LocalStorageWrapper.getKey(Constants.localStorageKeys.addReply, this.props.parentComment.id, this.props.currentUserId)});
      }

      if (!prevProps.hasFocus && this.props.hasFocus) {
         CommentScrollingService.scrollCommentIntoView(this.feedbackContainer, {alignment: 'end'});
      }
   }

   addNewReply(text: string): Promise<void> {
      if (text) {
         return this.props.addReply(text).then(() => {
            CommentScrollingService.scrollCommentIntoView(this.feedbackContainer, {alignment: 'end'});
            return Promise.resolve();
         });
      }

      return Promise.reject('No text supplied for reply');
   }

   render() {
      const {commentReplies, isEditable, hasFocus, onBlur, isSelected, onSelect} = this.props;

      return (
         <div role="region">
            {commentReplies && commentReplies.map(reply => <ReplyContainer
               key={reply.id}
               reply={reply}
               isEditable={isEditable}
               onSelect={onSelect}
            />)}
            {isSelected && <div className="comment-replies-feedback-container" ref={c => this.feedbackContainer = c}>
               <FeedbackContainer alternatePlaceholderText={Strings.labels.addReply} localStorageKey={this.state.replyLocalStorageKey} addComment={this.addNewReply} hasFocus={hasFocus} onBlur={onBlur} showAnnotationsBar={false}/>
            </div>}
         </div>
      );
   }
}

export interface CommentRepliesProps {
   parentComment: CommentModel;
   commentReplies: CommentModel[];
   isEditable: boolean;
   hasFocus: boolean;
   currentUserId: string;
   isSelected: boolean;
   onSelect(): void;
   onBlur(): void;
   addReply(text: string): Promise<any>;
}

export interface CommentRepliesState {
   replyLocalStorageKey: string;
}
